var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6508 11.2407C18.8724 11.4307 19 11.7081 19 12C19 12.2919 18.8724 12.5693 18.6508 12.7592L15.1508 15.7592C14.7315 16.1187 14.1002 16.0701 13.7407 15.6508C13.3813 15.2314 13.4299 14.6001 13.8492 14.2407L15.2967 13L9.5 13C8.94772 13 8.5 12.5523 8.5 12C8.5 11.4477 8.94772 11 9.5 11L15.2967 11L13.8492 9.75924C13.4299 9.39982 13.3813 8.76852 13.7407 8.34919C14.1002 7.92986 14.7315 7.8813 15.1508 8.24072L18.6508 11.2407ZM7 16L10 16L10 18L7 18C5.89543 18 5 17.1046 5 16L5 8C5 6.89543 5.89543 6 7 6L10 6L10 8L7 8L7 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcn);
export default __webpack_public_path__ + "static/media/logout-icn.a5abfeaa0c99b1c2065645db259e80ef.svg";
export { ForwardRef as ReactComponent };